import { Col, Row } from 'antd';
import React, { ReactElement } from 'react';
import { NEW_UPLOAD_STATUS } from '../../../constants/crmConstants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';

const FileCountHeader = ({ fileCount, minFileCount, fileLimit, uploadedFiles, showPreviouslyAddedFiles,
  payerWiseFileSize }: any): ReactElement | null => {
  const { uploadedFiles: fileList } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payerList: { payer } } = useSelector((state: RootState): any => state);
  const totalSizeInMBs = Math?.round(fileCount * fileLimit);
  const formattedPayerWiseFileSize = Math.round(payerWiseFileSize);
  let filesGroupByStatus = fileList?.reduce((result: any, currentElement: any): any => {
    result[currentElement?.claimStatus] = [...result[currentElement?.claimStatus] || [], currentElement];
    return result;
  }, {});

  if (!showPreviouslyAddedFiles && filesGroupByStatus) {
    filesGroupByStatus = filesGroupByStatus[NEW_UPLOAD_STATUS] ? { [NEW_UPLOAD_STATUS]: filesGroupByStatus[NEW_UPLOAD_STATUS] } : {};
  }

  if (filesGroupByStatus?.[NEW_UPLOAD_STATUS]) {
    const temp = filesGroupByStatus[NEW_UPLOAD_STATUS];
    delete filesGroupByStatus[NEW_UPLOAD_STATUS];
    filesGroupByStatus = {
      [NEW_UPLOAD_STATUS]: temp,
      ...filesGroupByStatus,
    };
  }
  return (
    <Row className={`file-container-His file-container text-center his-file-count-header-cont ${payer?.isRpaPayer ?
      'file-count-header-top-20-RPA' : 'file-count-header-top-20'}`}>
      <Col md={4} className="file-Icon margin-right-12 file-count-header file-header-padding"><span className="filecount flex-container-header">
        <span className="file-header-size">{fileLimit}MB / </span>&nbsp;<span className="size-text">  file size</span></span>
      </Col>
      <Col md={minFileCount ? 7 : 4} className="file-Icon margin-right-12 file-count-header file-header-padding">
        <span className="uploaded-files"><span className="file-header-size">{minFileCount ? `${minFileCount} min/ ` : ''}
          {fileCount ? `${fileCount} ${minFileCount ? 'max' : ''}` : '0'}</span> <span className="size-text">
            files allowed</span></span>
      </Col>
      <Col md={6} className="margin-right-12 file-count-header file-header-padding">
        <span className="filetotalcount file-header-size">
          {formattedPayerWiseFileSize ? formattedPayerWiseFileSize : totalSizeInMBs}MB </span>&nbsp;
        <span className="size-text">{`Total File Size`}</span>
      </Col>
    </Row>
  );
};
export default FileCountHeader;
